export default [
    {
        lat: 49.585,
        lng: 10.05,
    },
    {
        lat: 49.61,
        lng: 10.055,
    },
    {
        lat: 49.64,
        lng: 10.095,
    },
    {
        lat: 49.64,
        lng: 10.13,
    },
    {
        lat: 49.63,
        lng: 10.135,
    },
    {
        lat: 49.635,
        lng: 10.145,
    },
    {
        lat: 49.63,
        lng: 10.16,
    },
    {
        lat: 49.62,
        lng: 10.165,
    },
    {
        lat: 49.62,
        lng: 10.18,
    },
    {
        lat: 49.64,
        lng: 10.185,
    },
    {
        lat: 49.655,
        lng: 10.215,
    },
    {
        lat: 49.64,
        lng: 10.28,
    },
    {
        lat: 49.645,
        lng: 10.35,
    },
    {
        lat: 49.675,
        lng: 10.34,
    },
    {
        lat: 49.68,
        lng: 10.32,
    },
    {
        lat: 49.71,
        lng: 10.315,
    },
    {
        lat: 49.725,
        lng: 10.33,
    },
    {
        lat: 49.725,
        lng: 10.355,
    },
    {
        lat: 49.74,
        lng: 10.365,
    },
    {
        lat: 49.765,
        lng: 10.41,
    },
    {
        lat: 49.77,
        lng: 10.45,
    },
    {
        lat: 49.76,
        lng: 10.465,
    },
    {
        lat: 49.775,
        lng: 10.495,
    },
    {
        lat: 49.775,
        lng: 10.56,
    },
    {
        lat: 49.76,
        lng: 10.61,
    },
    {
        lat: 49.76,
        lng: 10.65,
    },
    {
        lat: 49.78,
        lng: 10.66,
    },
    {
        lat: 49.81,
        lng: 10.715,
    },
    {
        lat: 49.805,
        lng: 10.74,
    },
    {
        lat: 49.79,
        lng: 10.755,
    },
    {
        lat: 49.785,
        lng: 10.79,
    },
    {
        lat: 49.765,
        lng: 10.81,
    },
    {
        lat: 49.775,
        lng: 10.85,
    },
    {
        lat: 49.79,
        lng: 10.86,
    },
    {
        lat: 49.795,
        lng: 10.875,
    },
    {
        lat: 49.805,
        lng: 10.94,
    },
    {
        lat: 49.8,
        lng: 10.95,
    },
    {
        lat: 49.74,
        lng: 10.955,
    },
    {
        lat: 49.73,
        lng: 10.98,
    },
    {
        lat: 49.71,
        lng: 10.98,
    },
    {
        lat: 49.705,
        lng: 11.02,
    },
    {
        lat: 49.695,
        lng: 11.03,
    },
    {
        lat: 49.7,
        lng: 11.065,
    },
    {
        lat: 49.665,
        lng: 11.085,
    },
    {
        lat: 49.65,
        lng: 11.08,
    },
    {
        lat: 49.635,
        lng: 11.1,
    },
    {
        lat: 49.62,
        lng: 11.1,
    },
    {
        lat: 49.62,
        lng: 11.115,
    },
    {
        lat: 49.61,
        lng: 11.125,
    },
    {
        lat: 49.61,
        lng: 11.19,
    },
    {
        lat: 49.63,
        lng: 11.21,
    },
    {
        lat: 49.63,
        lng: 11.23,
    },
    {
        lat: 49.62,
        lng: 11.24,
    },
    {
        lat: 49.625,
        lng: 11.27,
    },
    {
        lat: 49.65,
        lng: 11.29,
    },
    {
        lat: 49.655,
        lng: 11.315,
    },
    {
        lat: 49.68,
        lng: 11.335,
    },
    {
        lat: 49.69,
        lng: 11.37,
    },
    {
        lat: 49.685,
        lng: 11.39,
    },
    {
        lat: 49.645,
        lng: 11.415,
    },
    {
        lat: 49.645,
        lng: 11.445,
    },
    {
        lat: 49.665,
        lng: 11.465,
    },
    {
        lat: 49.67,
        lng: 11.495,
    },
    {
        lat: 49.665,
        lng: 11.54,
    },
    {
        lat: 49.685,
        lng: 11.52,
    },
    {
        lat: 49.7,
        lng: 11.52,
    },
    {
        lat: 49.715,
        lng: 11.54,
    },
    {
        lat: 49.735,
        lng: 11.55,
    },
    {
        lat: 49.73,
        lng: 11.575,
    },
    {
        lat: 49.66,
        lng: 11.595,
    },
    {
        lat: 49.635,
        lng: 11.62,
    },
    {
        lat: 49.61,
        lng: 11.62,
    },
    {
        lat: 49.59,
        lng: 11.595,
    },
    {
        lat: 49.57,
        lng: 11.595,
    },
    {
        lat: 49.555,
        lng: 11.57,
    },
    {
        lat: 49.525,
        lng: 11.565,
    },
    {
        lat: 49.52,
        lng: 11.58,
    },
    {
        lat: 49.505,
        lng: 11.585,
    },
    {
        lat: 49.5,
        lng: 11.61,
    },
    {
        lat: 49.48,
        lng: 11.615,
    },
    {
        lat: 49.455,
        lng: 11.61,
    },
    {
        lat: 49.45,
        lng: 11.6,
    },
    {
        lat: 49.435,
        lng: 11.595,
    },
    {
        lat: 49.43,
        lng: 11.58,
    },
    {
        lat: 49.41,
        lng: 11.58,
    },
    {
        lat: 49.39,
        lng: 11.555,
    },
    {
        lat: 49.39,
        lng: 11.525,
    },
    {
        lat: 49.405,
        lng: 11.48,
    },
    {
        lat: 49.395,
        lng: 11.475,
    },
    {
        lat: 49.38,
        lng: 11.445,
    },
    {
        lat: 49.355,
        lng: 11.43,
    },
    {
        lat: 49.345,
        lng: 11.41,
    },
    {
        lat: 49.33,
        lng: 11.41,
    },
    {
        lat: 49.305,
        lng: 11.39,
    },
    {
        lat: 49.3,
        lng: 11.36,
    },
    {
        lat: 49.28,
        lng: 11.335,
    },
    {
        lat: 49.29,
        lng: 11.295,
    },
    {
        lat: 49.28,
        lng: 11.31,
    },
    {
        lat: 49.265,
        lng: 11.31,
    },
    {
        lat: 49.245,
        lng: 11.325,
    },
    {
        lat: 49.235,
        lng: 11.32,
    },
    {
        lat: 49.22,
        lng: 11.34,
    },
    {
        lat: 49.17,
        lng: 11.335,
    },
    {
        lat: 49.165,
        lng: 11.345,
    },
    {
        lat: 49.145,
        lng: 11.345,
    },
    {
        lat: 49.135,
        lng: 11.365,
    },
    {
        lat: 49.105,
        lng: 11.385,
    },
    {
        lat: 49.08,
        lng: 11.415,
    },
    {
        lat: 49.08,
        lng: 11.43,
    },
    {
        lat: 49.065,
        lng: 11.445,
    },
    {
        lat: 49.04,
        lng: 11.445,
    },
    {
        lat: 49.035,
        lng: 11.435,
    },
    {
        lat: 49.02,
        lng: 11.43,
    },
    {
        lat: 49.01,
        lng: 11.4,
    },
    {
        lat: 49,
        lng: 11.395,
    },
    {
        lat: 48.995,
        lng: 11.355,
    },
    {
        lat: 48.98,
        lng: 11.345,
    },
    {
        lat: 48.98,
        lng: 11.31,
    },
    {
        lat: 48.995,
        lng: 11.25,
    },
    {
        lat: 49.02,
        lng: 11.245,
    },
    {
        lat: 49.03,
        lng: 11.235,
    },
    {
        lat: 49.03,
        lng: 11.22,
    },
    {
        lat: 49.025,
        lng: 11.21,
    },
    {
        lat: 49.01,
        lng: 11.21,
    },
    {
        lat: 48.975,
        lng: 11.165,
    },
    {
        lat: 48.945,
        lng: 11.15,
    },
    {
        lat: 48.94,
        lng: 11.085,
    },
    {
        lat: 48.925,
        lng: 11.095,
    },
    {
        lat: 48.895,
        lng: 11.085,
    },
    {
        lat: 48.89,
        lng: 11.06,
    },
    {
        lat: 48.865,
        lng: 11.035,
    },
    {
        lat: 48.865,
        lng: 10.995,
    },
    {
        lat: 48.84,
        lng: 10.975,
    },
    {
        lat: 48.84,
        lng: 10.93,
    },
    {
        lat: 48.86,
        lng: 10.9,
    },
    {
        lat: 48.855,
        lng: 10.86,
    },
    {
        lat: 48.875,
        lng: 10.835,
    },
    {
        lat: 48.885,
        lng: 10.8,
    },
    {
        lat: 48.9,
        lng: 10.79,
    },
    {
        lat: 48.9,
        lng: 10.745,
    },
    {
        lat: 48.89,
        lng: 10.745,
    },
    {
        lat: 48.88,
        lng: 10.73,
    },
    {
        lat: 48.89,
        lng: 10.67,
    },
    {
        lat: 48.91,
        lng: 10.65,
    },
    {
        lat: 48.93,
        lng: 10.65,
    },
    {
        lat: 48.945,
        lng: 10.67,
    },
    {
        lat: 48.965,
        lng: 10.66,
    },
    {
        lat: 48.96,
        lng: 10.65,
    },
    {
        lat: 48.965,
        lng: 10.625,
    },
    {
        lat: 48.995,
        lng: 10.61,
    },
    {
        lat: 48.995,
        lng: 10.6,
    },
    {
        lat: 49.015,
        lng: 10.585,
    },
    {
        lat: 49.01,
        lng: 10.57,
    },
    {
        lat: 48.985,
        lng: 10.55,
    },
    {
        lat: 48.99,
        lng: 10.455,
    },
    {
        lat: 48.96,
        lng: 10.44,
    },
    {
        lat: 48.955,
        lng: 10.41,
    },
    {
        lat: 48.97,
        lng: 10.39,
    },
    {
        lat: 48.97,
        lng: 10.37,
    },
    {
        lat: 48.985,
        lng: 10.36,
    },
    {
        lat: 48.985,
        lng: 10.345,
    },
    {
        lat: 49.005,
        lng: 10.33,
    },
    {
        lat: 49.02,
        lng: 10.28,
    },
    {
        lat: 49.02,
        lng: 10.24,
    },
    {
        lat: 49.035,
        lng: 10.23,
    },
    {
        lat: 49.055,
        lng: 10.23,
    },
    {
        lat: 49.065,
        lng: 10.215,
    },
    {
        lat: 49.075,
        lng: 10.215,
    },
    {
        lat: 49.08,
        lng: 10.19,
    },
    {
        lat: 49.09,
        lng: 10.185,
    },
    {
        lat: 49.11,
        lng: 10.185,
    },
    {
        lat: 49.135,
        lng: 10.21,
    },
    {
        lat: 49.135,
        lng: 10.19,
    },
    {
        lat: 49.155,
        lng: 10.175,
    },
    {
        lat: 49.16,
        lng: 10.155,
    },
    {
        lat: 49.175,
        lng: 10.14,
    },
    {
        lat: 49.175,
        lng: 10.12,
    },
    {
        lat: 49.19,
        lng: 10.105,
    },
    {
        lat: 49.235,
        lng: 10.105,
    },
    {
        lat: 49.25,
        lng: 10.09,
    },
    {
        lat: 49.265,
        lng: 10.09,
    },
    {
        lat: 49.295,
        lng: 10.115,
    },
    {
        lat: 49.31,
        lng: 10.11,
    },
    {
        lat: 49.31,
        lng: 10.1,
    },
    {
        lat: 49.33,
        lng: 10.085,
    },
    {
        lat: 49.38,
        lng: 10.085,
    },
    {
        lat: 49.405,
        lng: 10.105,
    },
    {
        lat: 49.405,
        lng: 10.12,
    },
    {
        lat: 49.42,
        lng: 10.12,
    },
    {
        lat: 49.42,
        lng: 10.1,
    },
    {
        lat: 49.44,
        lng: 10.075,
    },
    {
        lat: 49.46,
        lng: 10.075,
    },
    {
        lat: 49.475,
        lng: 10.085,
    },
    {
        lat: 49.52,
        lng: 10.055,
    },
    {
        lat: 49.55,
        lng: 10.065,
    },
    {
        lat: 49.565,
        lng: 10.05,
    },
    {
        lat: 49.585,
        lng: 10.05,
    },
];
